export default __webpack_public_path__ + "static/media/book.b46462a4.png";